import apiExcel from '@/api/excel'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  excelAnalyticsStart: '[excel] excel analytics start',
  excelAnalyticsSuccess: '[excel] excel analytics success',
  excelAnalyticsFailure: '[excel] excel analytics failure'
}

export const actionTypes = {
  excelAnalytics: '[excel] analytics excel'
}

const mutations = {
  [mutationTypes.excelAnalyticsStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.excelAnalyticsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.excelAnalyticsFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.excelAnalytics](context, {id}) {
    context.commit(mutationTypes.excelAnalyticsStart)
    return new Promise(resolve => {
      apiExcel
        .analytics(id)
        .then(response => {
          context.commit(mutationTypes.excelAnalyticsSuccess)
          const file = new Blob([response.data], {
            type: response.headers['content-type']
          })

          const link = URL.createObjectURL(file)
          resolve(link)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.excelAnalyticsFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
